import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Query {\n    adultMode: Boolean! @cacheControl(scope: PRIVATE, maxAge: 86400)\n  }\n"])));
export var resolvers = {
  Query: {
    adultMode: function () {
      var _adultMode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var req;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req;
                return _context.abrupt("return", req.adultMode);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function adultMode(_x, _x2, _x3) {
        return _adultMode.apply(this, arguments);
      }

      return adultMode;
    }()
  }
};